import styles from './icon.less'; export {styles};

export default class Icon extends React.PureComponent<{onClick: Function}, null> {

    render() {
        return (
            <div className={styles.icon} onClick={() => this.props.onClick()}>
                <div className={styles.innerIcon}>
                    <div/>
                    <div/>
                    <div/>
                </div>
            </div>
        );
    }
}
